import React, { FC } from 'react';
import { MotifProgressLoader } from '@ey-xd/motif-react';
import './Loader.scss';

type LoaderProps = {
    isVisible: boolean;
};

const Loader: FC<LoaderProps> = ({ isVisible }) => {
    return (
        <MotifProgressLoader
            show={isVisible}
            fullscreen
            className="loader-background"
            data-testid={'loader'}
        />
    );
};

export default Loader;
